import React from 'react';
import { Button } from 'app/components';
import SliderHero from './slider-hero';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useLoginModal from '../../login/useLoginModal'; // Import the login modal hook
import './style';
import { CALENDAR_LINK } from '../../../constants/common';

const Hero = () => {
  const navigate = useNavigate();
  const loginModal = useLoginModal(); // Initialize the login modal
  const { userData } = useSelector((state) => state.app); // Get user data from Redux state

  const handleClick = () => {
    const phoneNumber = '9025082101';
    const message = "I'm very interested in your ticketing platform and would love to discuss it further.";
    const desktopUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const mobileUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const isMobile = window.innerWidth < 650; // For mobile, width less than 1024px

    const url = '/event/create';
    if (!userData?.email) {
          loginModal.onOpen();
      loginModal.callback.current = () => navigate(url);
    } else {
      navigate(url);
    }
  };

  return (
    <div className="p-4 pt-10 md:px-10 md:py-12 items-start bg-gradient-to-b from-[#ffd6e0] from-5% to-[#fff] to-95% flex flex-col gap-10 md:gap-24 md:overflow-hidden relative w-full h-auto pb-0">
      <div className="flex items-center md:items-start flex-row flex-nowrap gap-9 justify-between md:overflow-hidden relative w-full pb-12">
        {/* Left Section - Text Content */}
        <div className='md:w-max justify-around flex flex-col md:flex-row gap-7 m-auto mt-2 items-center md:items-center '> 
          <div className="flex flex-col gap-7 md:w-max md:max-w-3xl">
            <div className="text-grey-70 px-5 py-2 text-center flex items-center bg-white rounded-full w-fit">
              Lowest fees in the market!
            </div>
            <div className="heading-36 md:text-[64px] md:font-bold text-black md:leading-snug text-left">
              Affordable Event Ticketing       
              <img 
                src="/assets/images/ticket.png"
                className="w-[41px] h-[41px] md:w-[68px] md:h-[68px] inline"
                alt="Ticket Icon"
              />            
               Platform tailored to your needs. 
            </div>
            {/* Button */}
            <div className='hero-button hidden md:flex gap-4' >
              <Button type="primary" rounded="true" onClick={handleClick} // Set onClick to handleTicket
              >
                <div className='label-16'>List your event</div>
              </Button>
              <Button
                type="secondary"
                rounded={true}
                onClick={() => window.open(CALENDAR_LINK, '_blank', 'noopener,noreferrer')}
              >
                Book a Call
              </Button>
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="flex-shrink-0 flex items-stretch">
            <img
              src="/assets/images/fees.png"
              className="max-w-sm self-center"
              alt="Cheapest Fees"
            />
          </div>
          <div className='hero-button flex flex-col gap-4 md:hidden'>
              <Button type="primary" rounded="true" onClick={handleClick}>
                <div className='label-16'>List your event</div>
              </Button>
              <Button
                type="secondary"
                rounded={true}
                onClick={() => window.open(CALENDAR_LINK, '_blank', 'noopener,noreferrer')}
              >
                Book a Call
              </Button>
            </div>
        </div>
      </div>
      <div className='flex p-5 md:p-10 m-auto w-[95%] md:w-[70%]'>
        <SliderHero />
      </div>
    </div>
  );
};

export default Hero;
